<template>
    <div>
        <!-- <div v-if="data"> -->
        <public-head title="专业详情"></public-head>
        <div class="nav">
            <div class="nav-table">
                <div :class="currentTab==0?'nav-table-style':''" @click="swichNav(0)">基本信息</div>
                <div :class="currentTab==1?'nav-table-style':''" @click="swichNav(1)">就业前景</div>
                <div :class="currentTab==2?'nav-table-style':''" @click="swichNav(2)">开设院校</div>
            </div>
            <!-- <div :class="['seach-table', currentTab==2?'show':'hide']"> -->
            <!-- <div class='header'>
                <div class='header-flex' @click='dqtoggle'>
                    <div class='header-title'>{{diqu?diqu:"地区"}}</div>
                    <div :class="['font_family','header-title-icon', dqArea?'icon-shang':'icon-xiahua']"></div>
                </div>
                <div class='header-flex' @click='yxtoggle'>
                    <div class='header-title'>{{yxname?yxname:"院校类型"}}</div>
                    <div :class='["font_family", yxArea?"icon-shang":"icon-xiahua","header-title-icon"]'></div>
                </div>
                <div class='header-flex' @click='pctoggle'>
                    <div class='header-title'>{{bkpc?bkpc:"批次"}}</div>
                    <div :class='["font_family", pcArea?"icon-shang":"icon-xiahua", "header-title-icon"]'></div>
                </div>
                <div class='header-flex'>
                    <div class='font_family icon-sousuo1 header-title-icon'></div>
                </div>
            </div>-->
            <!-- <div :class='["sArea", dqArea?"show":""]'> -->
            <!-- data-aid='0' data-scid='{{xztype}}' data-pcid='{{xzpc}}' -->
            <!-- <div :class='xzsf==0?"yellow":""' @click='screen'>全部</div>
                <div data-aid='{{item.id}}' data-diqu='{{item.name}}' data-scid='{{xztype}}' data-pcid='{{xzpc}}' wx:for="{{reogin}}" wx:key="index" class='{{item.id==xzsf?"yellow":""}}' bindtap='screen'>{{item.name}}</div>
            </div>
            <div class='sArea {{yxArea?"show":""}}'>
                <div data-scid='0' data-pcid='{{xzpc}}' data-aid='{{xzsf}}' class='{{xztype==0?"yellow":""}}' bindtap='screen'>全部</div>
                <div data-scid='{{item.id}}' data-yxname='{{item.name}}' data-pcid='{{xzpc}}' data-aid='{{xzsf}}' wx:for="{{schooltype}}" wx:key="index" class='{{item.id==xztype ?"yellow":""}}' bindtap='screen'>{{item.name}}</div>
            </div>
            <div class='sArea {{pcArea?"show":""}}'>
                <div data-pcid='0' data-aid='{{xzsf}}' data-scid='{{xztype}}' class='{{xzpc==0?"yellow":""}}' bindtap='screen'>全部</div>
                <div data-pcid='{{item.id}}' data-bkpc='{{item.name}}' data-aid='{{xzsf}}' data-scid='{{xztype}}' wx:for="{{pici}}" wx:key="index" class='{{item.id==xzpc ?"yellow":""}}' bindtap='screen'>{{item.name}}</div>
            </div>
            </div>-->
        </div>
        <div class="ConArea scroller" ref="scroll">
            <div class="content">
                <div class="content-one">
                    <!-- <div class='content-one-title'> -->
                    <div class="major">
                        <div>{{bank.name}}</div>
                    
                        <div :class="bank.is_shoucang==1?'color':'shoucang'"  @click="shoucang(bank.id)"><van-icon name="star" />收藏</div>
                    </div>
                    <!-- <div class='b_right'>
                        <button class='font_family icon-fenxiang1 sharebtn' data-name="{{bank.name}}" data-id="{{bank.id}}" id="shareBtn" open-type="share"></button>
                        <div class='line'></div>
                        <button class='font_family sharebtn {{celled?"celled icon-shoucangshixin":"icon-shoucang"}}' id="shoucang" data-id='{{bank.id}}' bindtap='shoucang'></button>
                    </div>-->
                    <!-- </div> -->

                    <div class="major-number">
                        <span>专业代码：</span>
                        <span>{{data.professional_code}}</span>
                    </div>
                    <div class="major-degree">
                        <div>
                            <span>授予学位：</span>
                            <span>{{data.award_degree}}</span>
                        </div>
                        <div>
                            <span>修学年限：</span>
                            <span>{{data.study_years}}</span>
                        </div>
                    </div>
                </div>
                <!--  current="{{currentTab}}"-->
                <div class="tab-content" duration="300" @click="switchTab">
                    <div v-if="currentTab==0">
                        <div class="scroll-div">
                            <div class="content-two">
                                <div class="content-two-title">
                                    <div>专业介绍</div>
                                    <div class="iconfont icon-xiajiantou1 title-icon"></div>
                                </div>
                                <div class="content-div">
                                    <div>{{data.professional_introduction}}</div>
                                </div>
                            </div>

                            <div class="content-three" v-if="data.training_target">
                                <div class="content-two-title">
                                    <div>培养目标</div>
                                    <div class="iconfont icon-xiajiantou1 title-icon"></div>
                                </div>
                                <div class="content-div">
                                    <div>{{data.training_target}}</div>
                                </div>
                            </div>

                            <div class="content-three" v-if="data.training_requirements">
                                <div class="content-two-title">
                                    <div>培养要求</div>
                                    <div class="iconfont icon-xiajiantou1 title-icon"></div>
                                </div>
                                <div class="content-div">
                                    <div>{{data.training_requirements}}</div>
                                </div>
                            </div>

                            <div class="content-three" v-if="data.courses">
                                <div class="content-two-title">
                                    <div>开设课程</div>
                                    <div class="iconfont icon-xiajiantou1 title-icon"></div>
                                </div>
                                <div class="content-div">
                                    <div>{{data.courses}}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div>
                        <div class="content-three" v-if="currentTab==1">
                            <div class="content-two-title">
                                <div>就业方向</div>
                                <div class="iconfont icon-xiajiantou1 title-icon"></div>
                            </div>
                            <div class="content-div">
                                <div>{{data.sem}}</div>
                            </div>
                        </div>

                        <!-- <div class='content-three'>
                        <div class='content-two-title'>
                            <div>薪资曲线</div>
                            <div class='iconfont icon-xiajiantou1 title-icon'></div>
                        </div>
                        <div class='Salary-curve'>
                            <canvas canvas-id="lineCanvas" disable-scroll="true" class="canvas"></canvas>
                        </div>
                        </div>-->
                    </div>

                    <div>
                        <van-list
                            class="scroll-div"
                            v-if="currentTab==2"
                            :finished="finished"
                            finished-text="没有更多了"
                            @load="onLoad"
                        >
                            <div class="content-three">
                                <div class="content-two-title">
                                    <div class="content-three-title">开设院校</div>
                                    <!-- <div class='iconfont icon-xiajiantou1 title-icon'></div> -->
                                </div>
                                <div class="content-div">
                                    <!-- {{data.sem}} -->
                                    <!-- 学校列表 -->
                                    <div v-if="school_list">
                                        <div
                                            class="school-card"
                                            v-for="(sclist,index) in school_list"
                                            :key="index"
                                            @click="goSchoolDetail(sclist.id)"
                                        >
                                            <div style="display:flex;">
                                                <div class="school-photo">
                                                    <img :src="sclist.logo" />
                                                </div>
                                                <div class="school-card-center">
                                                    <div class="school-name">{{sclist.name}}</div>
                                                    <div class="school-type">
                                                        <div>{{sclist.province}}</div>
                                                        <div>{{sclist.institution_str}}</div>
                                                        <div>{{sclist.disciplinary_level}}</div>
                                                    </div>
                                                </div>
                                                <div class="school-leve">
                                                    <div>{{sclist.label_str}}</div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <!-- <div wx:else>
                                    <img src="/images/school_name.jpg" class="nopost" />
                                    
                                    <div class='_empty'>暂无数据！！！</div>
                                    </div>-->
                                    <!-- </div> -->
                                </div>
                            </div>
                        </van-list>
                    </div>
                </div>
            </div>
        </div>
        <!-- <div v-:else>
    <img src="/images/nopost.png" class="nopost" />
    <div style="div-align:center;font-size:24rpx;background:#fff;padding:40rpx;">抱歉!!!暂无数据</div>
        </div>-->
        <!-- <div wx:if='{{isretrue == 1}}'>
    <div class='returnHome' bindtap='returnHome'>
        <image src='/images/rindex.png'></image>
    </div>
        </div>-->
    </div>
</template>

<script>
import { httpPost } from "../../../axios/index";
import PublicHead from "../../../components/publicHead";
export default {
    data() {
        return {
            busy: false,
            career_id: 0,
            bank: [],
            data: [],
            school_list: [],
            celled: false,
            winHeight: "", //窗口高度
            currentTab: 0, //预设当前项的值
            scrollLeft: 0, //tab标题的滚动条位置
            xzsf: 0,
            xztype: 0,
            xzpc: 0,
            page: 1,
            num: 10,
            isEnded: false, //loading的显示消失
            pici: [
                {
                    id: 1,
                    name: "一本"
                },
                {
                    id: 2,
                    name: "二本"
                },
                {
                    id: 4,
                    name: "专科"
                }
            ],
            dqArea: false,
            yxArea: false,
            pcArea: false,
            isretrue: 0,
            careerId: 0 ,//存储专业id
            finished:false,
            celled:false
        };
    },
    created() {},
    methods: {
        // 点击收藏
        shoucang(e){
          
        if (this.$store.state.userInfo.user_id!= null) {
             httpPost("/usercell/career_cell", {
                      uid:this.$store.state.userInfo.user_id,
                    career_id: e
                }).then(res => {
                    if (res.msg=="收藏成功") {
                           this.bank.is_shoucang=1;
                          this.$toast.success(res.msg);
                    }else{
                        this.bank.is_shoucang=0;
                         this.$toast.fail(res.msg);
                    }
            })
        }else{
            this.$toast("请先去登录");
        }
        },
        // 上拉加载
        onLoad() {
            this.page = this.page + 1;
            if (!this.finished) {
                httpPost("/career/career_school", {
                    cid: this.$route.query.id,
                    page: this.page
                }).then(res => {
                    if (res.code === 1) {
                        this.school_list = [
                            ...this.school_list,
                            ...res.school_list
                        ];
                    }
                    this.$toast.loading({
                            message: "加载中...",
                            forbidClick: true
                        });
                });
            }
        },
        // 进入学校详情
        goSchoolDetail(e) {
            this.$router.push({path:"/schoolDetail",query:{id:e}});
        },
        // 点击切换
        swichNav(e) {
            this.currentTab = e;
        },
        switchTab(e) {
           
        },
        //    获取详情数据
        fetchList() {
            httpPost("/career/detail", {
                id: this.$route.query.id
            }).then(res => {
               
                if (res.code === 1) {
                    (this.data = res.detail), (this.bank = res.bank);
                    // this.celled= res.bank.is_shoucang
                }
            });
        },
        // 获取相关学校列表
        fetchSchoolList() {
            httpPost("/career/career_school", {
                cid: this.$route.query.id,
                page: this.page
            }).then(res => {
              
                if (res.code === 1) {
                    //  this.cid= res.careerId,
                    //  this.page= this.page,
                    this.school_list = res.school_list;
                }
            });
        }
    },
    mounted() {
        window.addEventListener("scroll", this.onScroll);
        this.fetchList();
        this.fetchSchoolList();
    },
    components: {
        PublicHead
    }
};
</script>

<style scoped>
/* pages/career/details/baseinfo.wxss */
.shoucang{
    line-height: 36px;
    width: 54px;
    height: 36px;
    background: #bcbcbc;
    font-size: 14px;
    color: #fff;
    text-align: center;
    border-radius: 10px
}
.color{
     line-height: 36px;
    width: 54px;
    height: 36px;
    background: #bcbcbc;
    font-size: 14px;
      color: rgb(233, 248, 18);
    text-align: center;
    border-radius: 10px
}
.seach-table {
    display: flex;
    justify-content: space-around;
    text-align: center;
}

.sousuo {
    font-size: 1.625rem;
}

.nav {
    background: #22d9d9;
    font-size: 0.875rem;
    color: #fff;
    line-height: 2.875rem;
    padding-bottom: 0.625rem;
}

.nav-table {
    width: 75%;
    margin: 0 auto;
    display: flex;
    justify-content: space-around;
    padding-top: 0.3125rem;
    margin-top: 46px;
}

.nav-table div {
    height: 1.75rem;
    padding: 0 0.875rem;
    line-height: 1.75rem;
}

.nav-table-style {
    background: #6de7e7;
    border-radius: 1.25rem;
}
.ConArea {
    background: #fafafa;
    padding: 0.625rem 0.625rem;
    overflow: hidden;
}
.content {
    background: #fff;
    box-shadow: 2px 3px 3px #ccc;
}

.content-one {
    padding: 0.625rem;
    border-bottom: 1px solid #ccc;
}

.content-one-title {
    display: flex;
    justify-content: space-between;
}

.major {
    font-size: 1.125rem;
    line-height: 2;
    display: flex;
    justify-content: space-between;
    box-sizing: border-box;
    padding-right:1.25rem;
}

.b_right {
    width: 5.625rem;
    height: 1.875rem;
    background: #bcbcbc;
    display: flex;
    justify-content: space-around;
    border-radius: 5px;
    line-height: 1.875rem;
    text-align: center;
}

.share {
    color: #fff;
    font-size: 1.375rem;
    margin-left: 0.375rem;
    margin-top: 0.1875rem;
}

.share2 {
    color: #fff;
    font-size: 1.4375rem;
    line-height: 1.4;
}

.line {
    height: 70%;
    width: 1px;
    background: #fff;
    margin-top: 5%;
}

.major-number {
    font-size: 0.875rem;
    color: #999;
    margin-top: 0.9375rem;
}

.major-degree {
    display: flex;
    justify-content: space-between;
    font-size: 0.9375rem;
    color: #999;
    padding-right: 2.5rem;
}

.content-two {
    padding: 0.625rem;
    border-bottom: 1px solid #ccc;
}

.content-two-title {
    font-size: 1.0625rem;
    display: flex;
    justify-content: space-between;
}

.title-icon {
    font-size: 1.25rem;
    color: #999;
}

.content-div {
    font-size: 1rem;
    color: #666;
    padding: 0.625rem 0;
    line-height: 1.5;
    letter-spacing: 2px;
    padding-left: 1.25rem;
}

.canvas {
    width: 21.875rem;
    height: 15.625rem;
    margin-left: -0.625rem;
}

.Salary-curve {
    padding-top: 0.9375rem;
}

.sharebtn {
    background: none;
    background: none;
    border: none;
    color: #fff;
    font-size: 1.25rem;
    height: 1.875rem;
    line-height: 1.125rem;
    width: 100%;
    padding: 0.5625rem 0.9375rem;
}

.school-card {
    padding: 0.9375rem 0.625rem;
    background: #fff;
    box-shadow: 0px 0px 0.125rem 0px #ccc;
}

.content-three {
    padding: 0.625rem;
}

.content-three-title {
    padding: 0.625rem;
}

.school-photo {
    width: 3.5rem;
    height: 3.5rem;
    border-radius: 50%;
    margin-right: 10px;
}

.school-photo img {
    width: 100%;
    height: 100%;
}

.school-card-center {
    font-size: 0.875rem;
    width: 60%;
}

.school-type {
    font-size: 0.75rem;
    display: flex;
}

.school-type div {
    padding-left: 0.25rem;
}

.school-type div:nth-child(1) {
    padding-left: 0;
}

.school-leve {
    font-size: 0.875rem;
    /* line-height: 2.375rem; */
}
.school-leve div {
    margin: 0 0.1875rem;
}

.school-name {
    line-height: 1.9;
}

.hide {
    display: none;
}
.show {
    display: flex;
}

/**************/
.header {
    height: 2.5rem;
    background: #22d9d9;
    display: flex;
    justify-content: space-around;
    padding: 0 20rpx;
}

.header-title {
    font-size: 1rem;
    color: #fff;
}

.header-flex {
    display: flex;
}

.header-title-icon {
    font-size: 1rem;
    color: #fff;
    line-height: 2.8;
    padding-left: 0.3125rem;
}

.sArea {
    display: none;
    position: absolute;
    top: 5rem;
    height: auto;
    line-height: 2.125rem;
    background: #22d9d9;
    font-size: 0.875rem;
    padding: 0.3125rem 0.625rem;
    color: #fff;
    width: 0%;
    transition: width 2s;
    overflow: hidden;
    z-index: 9999;
}

.sArea div {
    float: left;
    width: 25%;
    text-align: center;
    overflow: hidden;
}

.show {
    display: div;
    width: 100%;
}

.yellow {
    color: yellow;
}

.empty {
    padding: 0.9375rem;
    font-size: 0.9375rem;
    text-align: center;
}

.listArea {
    display: div;
    width: 100%;
    overflow: hidden;
}
.scroll-div {
    height: 100%;
}

.school-card navigator {
    width: 100%;
    height: auto;
    display: flex;
    justify-content: space-between;
}

.celled {
   color: #e5b626;
    font-size: 1.75rem;
    margin-left: -0.1875rem;
}
._empty {
    width: 100%;
    text-align: center;
}
</style>